export const pl = {
  nav: {
    pillars: "Działania", network: "Sieć", wrd: "Światowy Dzień Rabarbaru", knowledge: "Wiedza",
    transparency: "Przejrzystość", join: "Dołącz do stowarzyszenia", brandTop: "World Rhubarb", brandBottom: "Association",
  },
  footer: {
    tagline: "Globalna sieć łącząca ludzi i organizacje, które rozwijają branżę rabarbarową.",
    ledger: ["Status: etap fundacyjny", "Założona: 2026", "Założyciel / Reprezentant: Kohei Sudo", "Zespół: 2 osoby · Członkowie zewnętrzni: 0", "Osobowość prawna: inicjatywa dobrowolna"],
    orgTitle: "Organizacja",
    orgLinks: ["Wizja i misja", "Mapa drogowa", "Przejrzystość", "Kontakt"],
    initTitle: "Inicjatywy",
    initLinks: ["Światowy Dzień Rabarbaru", "Rozwój rynku", "Centrum wiedzy", "Globalna baza danych"],
    refTitle: "Modele referencyjne",
    copyright: "© 2026 World Rhubarb Association",
    verified: "Tylko zweryfikowane dane · Żadnych zmyślonych liczb",
  },
  hero: {
    kicker: "World Rhubarb Association — zał. 2026",
    h1a: "Łączymy świat", h1bPre: "", h1b: "poprzez", h1c: "rabarbar.",
    para: "Łączymy producentów rabarbaru, naukowców, firmy i entuzjastów na całym świecie — rozwijamy branżę rabarbarową i budujemy jej zrównoważoną przyszłość.",
    ctaJoin: "Dołącz do stowarzyszenia", ctaActivities: "Nasze działania",
    stats: [["Założona", "2026"], ["Zespół", "2"]],
    statMembers: "Zarejestrowani członkowie", statCountries: "Kraje",
    statsNote: "Dane dokładne na dzień startu · Aktualizujemy je wraz z rozwojem sieci",
    specimen: "Okaz · Pole rabarbaru, uprawa polowa",
  },
  marquee: ["Rheum rhabarbarum", "Założona w 2026", "Budujemy sieć fundatorską", "Zero przechwałek", "Producenci · Naukowcy · Szefowie kuchni", "Inicjatywa Światowego Dnia Rabarbaru", "Tylko zweryfikowane dane"],
  pillars: {
    kicker: "Nasze działania",
    title: "Sześć działań, realizowanych jawnie.",
    items: [
      { title: "Łączymy producentów", text: "Łączymy producentów rabarbaru z całego świata, wspierając wymianę wiedzy, współpracę i otwieranie nowych kanałów sprzedaży.", tags: ["Wymiana wiedzy", "Współpraca", "Nowe kanały sprzedaży"] },
      { title: "Rozwijamy rynek", text: "Otwieramy nowe zastosowania, produkty i rynki dla rabarbaru, zwiększając popyt na całym świecie.", tags: ["Nowe zastosowania", "Rozwój produktów", "Globalny popyt"] },
      { title: "Wspieramy nowych producentów", text: "Pomagamy nowym producentom rozpocząć uprawę — wiedzą o uprawie, sprawdzonymi przykładami i informacjami rynkowymi.", tags: ["Wiedza o uprawie", "Sprawdzone przykłady", "Informacje rynkowe"] },
      { title: "Badania i dane", text: "Zbieramy informacje o światowej produkcji, dystrybucji, odmianach i rynkach rabarbaru — i gromadzimy je w bazie danych.", tags: ["Produkcja", "Odmiany", "Dane rynkowe"] },
      { title: "Współpraca międzynarodowa", text: "Budujemy międzynarodowe powiązania z organizacjami, uczelniami, naukowcami, firmami i administracją publiczną.", tags: ["Organizacje", "Uczelnie", "Administracja"] },
      { title: "Światowy Dzień Rabarbaru", text: "Dążymy do ustanowienia i upowszechnienia Światowego Dnia Rabarbaru, zwiększając świadomość tej rośliny na świecie.", tags: ["Świadomość", "Ustanowienie", "Globalne święto"] },
    ],
  },
  network: {
    kicker: "Nasza globalna sieć",
    titleA: "Budujemy naszą ", titleAccent: "sieć fundatorską.",
    para: "Dziś sieć to dwuosobowy zespół fundatorski. Każdy, kto dołączy dalej, będzie realną osobą lub organizacją, która formalnie zgodziła się na udział — a żadne nazwisko nie zostanie opublikowane bez zgody.",
    stages: [
      { stage: "Zespół fundatorski", note: "2026 · 2 osoby · Aktywny", state: "active" },
      { stage: "Sieć fundatorska", note: "W budowie — zgłoszenia otwarte", state: "building" },
      { stage: "Sieć międzynarodowa", note: "Członkowie w wielu krajach", state: "future" },
      { stage: "Globalna platforma branżowa", note: "Długoterminowy cel", state: "future" },
    ],
    stateLabels: { active: "Teraz", building: "W budowie", future: "Przyszłość" },
    mapKicker: "Mapa globalnej sieci",
    globeNote: "Węzły oznaczają otwarte regiony · Status sieci: faza fundacyjna",
    chapterNote: "Oddział krajowy — jeszcze nie ustanowiony",
    regionStatus: "Przedstawiciel krajowy — wakat",
    regions: ["Azja Wschodnia i Południowo-Wschodnia", "Europa", "Ameryka Północna", "Ameryka Południowa", "Afryka", "Oceania"],
    regionsNote: "Liczba reprezentowanych krajów: 0. Oddziały pojawią się tutaj dopiero po formalnym powołaniu — nigdy wcześniej.",
  },
  manifesto: {
    kicker: "Dlaczego istniejemy — manifest w trzech rozdziałach",
    chapters: [
      { title: "Przeoczona bylina", text: "Od szklarni w Yorkshire po pola Hokkaido rabarbar karmił ludzi przez wieki — a mimo to nie ma globalnego głosu, wspólnych danych ani zjednoczonej branży. Wartość jest prawdziwa. Po prostu rozproszona." },
      { title: "Rozproszona branża", text: "Producenci, naukowcy, szefowie kuchni i firmy spożywcze działają każdy na własną rękę. Wiedza tkwi zamknięta w oddzielnych instytucjach. Informacje rynkowe są rozproszone — albo w ogóle ich nie ma. Nikt nie łączy tych elementów." },
      { title: "Od dwóch osób do platformy", text: "WRA zaczyna tam, gdzie uczciwie jest: dwuosobowy zespół fundatorski w 2026, zero członków zewnętrznych, zero partnerów. Nasza strategia to nie udawanie skali, lecz jej zdobycie — dwie osoby, potem sieć fundatorska, sieć międzynarodowa, a w końcu globalna platforma branży rabarbarowej." },
    ],
  },
  mission: {
    kicker: "Wizja i misja", visionLabel: "Wizja", missionLabel: "Misja",
    vision: "Świat, w którym ekonomiczna i kulturowa wartość rabarbaru jest w pełni realizowana — a wszyscy, którzy go uprawiają, badają, gotują i sprzedają, są ze sobą połączeni.",
    items: [
      "Rozwijać globalny rynek rabarbaru — i zabezpieczać producentów, którzy za nim stoją — przez świadomość, rozwój produktów i współdzielenie wiedzy rynkowej.",
      "Budować międzynarodową sieć producentów, naukowców, firm i entuzjastów.",
      "Dążyć do ustanowienia Światowego Dnia Rabarbaru jako międzynarodowo uznawanego święta.",
    ],
  },
  who: {
    kicker: "Kto może dołączyć",
    title: "Siedem grup ludzi buduje branżę.",
    items: [
      { title: "Producenci", text: "Producenci rabarbaru w każdym kraju — uprawa polowa i przyspieszona, komercyjna i drobna, doświadczeni i ci, którzy dopiero zaczynają." },
      { title: "Naukowcy", text: "Uczelnie i instytuty z zakresu nauk o roślinach, agronomii i nauki o żywności." },
      { title: "Firmy spożywcze", text: "Producenci, przetwórcy i firmy rozwijające produkty." },
      { title: "Szefowie kuchni", text: "Restauracje i profesjonaliści kulinarni kształtujący gastronomię rabarbarową." },
      { title: "Sprzedawcy", text: "Handel detaliczny, dystrybucja oraz import i eksport." },
      { title: "Organizacje rolnicze", text: "Zrzeszenia producentów, organizacje regionalne i spółdzielnie." },
      { title: "Entuzjaści", text: "Ogrodowi amatorzy, kucharze i wszyscy, którzy po prostu kochają rabarbar." },
    ],
    ctaCard: "Kimkolwiek jesteś — sieć zaczyna się od Ciebie.",
    cta: "Dołącz do sieci",
  },
  membership: {
    kicker: "Członkostwo",
    titleA: "Sieć fundatorska — ", titleAccent: "obecnie w budowie.",
    para: "Członkowie zewnętrzni dziś: zero. Zamiast wymyślać listę, najpierw publikujemy zasady. Formalna polityka członkowska jest w przygotowaniu i pojawi się na stronie Przejrzystość, zanim wymienimy pierwszego członka.",
    principles: [
      { t: "Publikacja za zgodą", d: "Nazwiska, kraje i role publikujemy wyłącznie za formalną, pisemną zgodą." },
      { t: "Zarząd w przygotowaniu", d: "Rada doradcza, komitety i przedstawiciele krajowi to planowane struktury — nie obsadzone stanowiska." },
      { t: "Otwarte kategorie", d: "Producenci, naukowcy, firmy, szefowie kuchni, sprzedawcy, organizacje rolnicze, entuzjaści." },
    ],
    specimen: "Okaz · Świeżo związane łodygi na targu",
  },
  whyJoin: {
    kicker: "Dlaczego warto dołączyć do sieci fundatorskiej?",
    title: "Sześć powodów, by dołączyć wcześnie.",
    items: [
      { title: "Międzynarodowe kontakty", text: "Połącz się z producentami rabarbaru, naukowcami, firmami i organizacjami z całego świata." },
      { title: "Tytuł członka fundatorskiego", text: "Zostaniesz uznany za członka fundatorskiego w fazie zakładania." },
      { title: "Widoczność w katalogu", text: "Opcjonalna obecność w Globalnym Katalogu Członków — tylko jeśli sobie tego życzysz." },
      { title: "Wymiana wiedzy", text: "Międzynarodowa wymiana wiedzy o uprawie, rynku i badaniach." },
      { title: "Spotkania międzynarodowe", text: "Możliwość udziału w przyszłych międzynarodowych spotkaniach online." },
      { title: "Możliwości współpracy", text: "Potencjalne możliwości współpracy badawczej, biznesowej i innej." },
    ],
    note: "Członkostwo jest bezpłatne w fazie zakładania i otwarte dla całego świata. Te korzyści opisują możliwości — niczego nie gwarantujemy.",
    cta: "Dołącz do sieci fundatorskiej",
  },
  market: {
    kicker: "Filar I — Rozwój rynku",
    titleA: "Rozwój rynku, ", titleAccent: "konkretnie.",
    items: [
      { title: "Świadomość konsumentów", text: "Czym jest rabarbar, kuchnie świata, historia, odmiany, uprawa, sezonowość i przepisy — publikowane dla globalnej publiczności.", alt: "Łodygi rabarbaru w karminowych odcieniach" },
      { title: "Rozwój produktów", text: "Dżemy, sosy, napoje, desery, wypieki, produkty fermentowane, przyprawy, wyroby cukiernicze i zastosowania pozażywnościowe. Żadnych niezweryfikowanych twierdzeń zdrowotnych — nigdy.", alt: "Świeże łodygi rabarbaru" },
      { title: "Producenci i łączenie ich z firmami", text: "Pomagamy regionom pozyskiwać i utrzymywać producentów rabarbaru — a następnie łączymy ich przez przyszły katalog producentów i katalog firm: producenci dostarczają surowiec, firmy tworzą produkty, restauracje budują menu.", alt: "Polowa uprawa rabarbaru" },
      { title: "Dane rynkowe", text: "Globalna baza danych rynku rabarbaru — produkcja, odmiany, sezony, handel. Gdy danych nie ma, mówimy to wprost: dane niedostępne.", alt: "Okazy badawcze z zakresu agronomii" },
    ],
  },
  international: {
    kicker: "Filar II — Sieć międzynarodowa",
    title: "Jak buduje się sieć — krok po kroku.",
    items: [
      { t: "Sieć fundatorska", d: "W budowie. Formalny udział na zaproszenie i przez zgłoszenie — publikujemy wyłącznie potwierdzonych uczestników." },
      { t: "Zasięg międzynarodowy", d: "Otwarty apel do producentów, zrzeszeń, uczelni, naukowców, firm spożywczych, szefów kuchni i sprzedawców na całym świecie — w tym pomoc nowym regionom w pozyskaniu pierwszych producentów rabarbaru." },
      { t: "Przedstawiciele krajowi", d: "Wprowadzani, gdy kraj osiągnie masę krytyczną członków. Publikowani wyłącznie po formalnym powołaniu." },
      { t: "Oddziały krajowe", d: "Przyszłe struktury jak WRA Japan, WRA UK, WRA Poland — tworzone z jasną, publiczną relacją z WRA." },
      { t: "Spotkania międzynarodowe", d: "Spotkania online, webinary, seminaria naukowe, spotkania producentów, a z czasem konferencje międzynarodowe." },
    ],
  },
  wrd: {
    kicker: "Filar III — Światowy Dzień Rabarbaru",
    badge: "Inicjatywa · Propozycja — jeszcze nieoficjalna",
    titleA: "Globalne święto rabarbaru — ", titleAccent: "zdobyte, nie ogłoszone.",
    para: "Dążymy do ustanowienia Światowego Dnia Rabarbaru jako międzynarodowo uznawanego święta rabarbaru, jego producentów, kultury i przyszłości. Proces jest jawny: badania, propozycja, poparcie, organizatorzy krajowi, a potem kampania globalna.",
    cta1: "Poznaj inicjatywę", cta2: "Wesprzyj Światowy Dzień Rabarbaru",
    phases: [
      { p: "Faza 1", t: "Badania i propozycja", d: "Globalne konsultacje o historii, kulturze, sezonach i odpowiedniej dacie." },
      { p: "Faza 2", t: "Poparcie międzynarodowe", d: "Poparcie producentów, uczelni, organizacji i szefów kuchni — publikowane za zgodą." },
      { p: "Faza 3", t: "Organizatorzy krajowi", d: "Krajowi przedstawiciele i oddziały prowadzą święto lokalnie." },
      { p: "Faza 4", t: "Kampania globalna", d: "Wydarzenia, targi, konkursy i edukacja — skoordynowane globalnie." },
    ],
  },
  knowledge: {
    kicker: "Centrum wiedzy o rabarbarze",
    titleA: "Wiedza warta ", titleAccent: "cytowania.",
    para: "Biblioteka oparta na dowodach — w przygotowaniu. Artykuły będą cytować badania uniwersyteckie, źródła rządowe, organizacje rolnicze i recenzowane publikacje, gdziekolwiek to możliwe.",
    statusLabel: "Status biblioteki",
    statusText: "Zbieranie materiałów od 2026 — artykuły publikowane stopniowo, każdy z podanymi źródłami.",
    categories: ["Uprawa", "Odmiany", "Nauki o roślinach", "Nauka o żywności", "Przetwórstwo", "Zrównoważony rozwój", "Ekonomia", "Historia", "Kultura"],
    catNote: "W przygotowaniu",
  },
  database: {
    kicker: "Globalna baza danych rabarbaru",
    titleA: "Dziś pusta. ", titleAccent: "Zawsze uczciwa.",
    para: "Długoterminowe aktywo danych WRA: zweryfikowane rekordy światowej branży rabarbarowej. Żadnych zmyślonych liczb — gdy brak zweryfikowanych danych, pole po prostu brzmi „dane niedostępne”.",
    badge: "Dane niedostępne",
    items: [
      { name: "Kraje", desc: "Profile rabarbarowe krajów" },
      { name: "Producenci", desc: "Rejestr producentów" },
      { name: "Odmiany", desc: "Rekordy odmian" },
      { name: "Naukowcy", desc: "Sieć akademicka" },
      { name: "Firmy", desc: "Firmy spożywcze i przetwórcze" },
      { name: "Organizacje", desc: "Powiązane instytucje" },
      { name: "Wydarzenia", desc: "Wydarzenia rabarbarowe na świecie" },
      { name: "Badania", desc: "Studia i źródła" },
    ],
  },
  roadmap: {
    kicker: "Nasza mapa drogowa", title: "2026 → 2030",
    disclaimer: "Wizja długoterminowa — nie sztywny harmonogram", now: "Teraz",
    items: [
      { year: "2026", title: "Fundament", items: ["Start WRA", "Formowanie zespołu", "Początek zasięgu międzynarodowego"], active: true },
      { year: "2027", title: "Sieć globalna", items: ["Członkowie fundatorzy", "Międzynarodowi producenci i naukowcy", "Przedstawiciele krajowi"] },
      { year: "2028", title: "Wiedza i dane", items: ["Globalna baza danych", "Centrum wiedzy", "Sieć badawcza"] },
      { year: "2029", title: "Rozwój rynku", items: ["Łączenie producentów i firm", "Międzynarodowy rozwój produktów", "Badania rynku globalnego"] },
      { year: "2030", title: "Światowy Dzień Rabarbaru", items: ["Kampania globalna", "Wydarzenia międzynarodowe", "Obchody krajowe"] },
    ],
  },
  join: {
    kicker: "Dołącz do ruchu",
    titleA: "Zostań członkiem ", titleAccent: "sieci fundatorskiej", titleB: "",
    para: "WRA ruszyła w 2026 z dwuosobowym zespołem fundatorskim. Wszystko dalej budujemy razem z ludźmi, którzy dołączą następni. Zarejestruj swoje zainteresowanie — odezwiemy się, gdy struktura członkostwa fundatorskiego zostanie sformalizowana.",
    bullets: [
      "Publikujemy wyłącznie potwierdzonych uczestników — za ich zgodą",
      "Nie ustalono składki członkowskiej; polityka zostanie najpierw opublikowana",
      "Producenci, naukowcy, szefowie kuchni, firmy i entuzjaści — wszyscy są mile widziani",
    ],
    formTitle: "Sieć fundatorska — deklaracja zainteresowania",
    ph: { name: "Imię i nazwisko *", email: "E-mail *", country: "Kraj", org: "Organizacja (opcjonalnie)", message: "Napisz, jak chcesz się zaangażować (opcjonalnie)" },
    categoryPh: "Jestem… *",
    categories: ["Producent", "Naukowiec / Uczelnia", "Firma spożywcza", "Szef kuchni / Restauracja", "Sprzedawca / Dystrybutor", "Organizacja rolnicza", "Entuzjasta", "Inne"],
    submit: "Dołącz do sieci", submitting: "Wysyłanie…",
    note: "Zapisane jako deklaracja — formalne członkostwo rusza z publikacją polityki",
    thanks: "Dziękujemy",
    success: "Wysłaliśmy link potwierdzający na Twój e-mail. Rejestracja zakończy się po kliknięciu linku.",
    toastOk: "Deklaracja zainteresowania zapisana.",
    toastErr: "Wysyłanie nie powiodło się. Spróbuj ponownie.",
  },
  wrdPage: {
    kicker: "Inicjatywa Światowego Dnia Rabarbaru",
    badge: "Propozycja · Kampania w przygotowaniu",
    h1a: "Światowy", h1b: "Dzień", h1c: "Rabarbaru",
    sub: "Globalne święto rabarbaru, jego producentów, kultury i przyszłości.",
    para: "Dążymy do ustanowienia Światowego Dnia Rabarbaru jako międzynarodowo uznawanego święta. Nie jest to jeszcze oficjalny dzień — ta strona dokumentuje jawny proces zdobywania tego uznania.",
    cta: "Wesprzyj inicjatywę",
    specimen: "Okaz · Łodygi rabarbaru w karminowych odcieniach",
    why: {
      kicker: "Dlaczego Światowy Dzień Rabarbaru?",
      items: [
        { title: "Dziedzictwo kulturowe", text: "Rabarbar niesie wieki kultury kulinarnej — od angielskich szklarni po azjatyckie tradycje lecznicze i nowoczesne kuchnie nordyckie. Zasługuje na wspólny moment uznania." },
        { title: "Uznanie producentów", text: "Dzień stawiający producentów na pierwszym miejscu: ludzi, którzy sadzą, przyspieszają, zbierają i wiążą jedną z najbardziej charakterystycznych roślin świata." },
        { title: "Sezonowa gastronomia", text: "Stały punkt w kalendarzu dla szefów kuchni, restauracji i marek spożywczych, by świętować rabarbar w szczycie sezonu — na obu półkulach." },
        { title: "Różnorodność rolnicza", text: "Uwaga dla odmian, wiedzy o uprawie i badań, które utrzymają rabarbar żywotnym na następne stulecie." },
      ],
    },
    proposal: {
      kicker: "Nasza propozycja",
      para: "Inicjatywa przechodzi przez cztery fazy robocze. Każda faza daje publiczny artefakt — badania, pisemną propozycję, rejestr zwolenników i ramy kampanii — publikowane na tej stronie po ukończeniu.",
      artifactLabel: "Aktualny artefakt",
      artifact: "Propozycja Światowego Dnia Rabarbaru — w trakcie badań, zostanie opublikowana jawnie.",
      phases: [
        { p: "Faza 1", t: "Badania i propozycja", d: "Konsultacje z producentami, organizacjami i naukowcami o historii, kulturze, regionach produkcji, sezonach zbiorów i odpowiedniej dacie — a potem publikacja propozycji." },
        { p: "Faza 2", t: "Poparcie międzynarodowe", d: "Zaproszenie do poparcia dla producentów, uczelni, organizacji rolniczych, firm spożywczych, szefów kuchni i restauracji. Nazwiska publikowane wyłącznie za formalną zgodą." },
        { p: "Faza 3", t: "Oddziały krajowe / Przedstawiciele", d: "Rekrutacja organizatorów krajowych — np. Światowy Dzień Rabarbaru – Japonia, – Wielka Brytania, – Polska — z jasną, publiczną relacją z WRA." },
        { p: "Faza 4", t: "Kampania globalna", d: "Kampanie w mediach społecznościowych, wydarzenia na farmach, targi restauracyjne, kampanie produktowe, programy szkolne i uniwersyteckie, konkursy kulinarne i fotograficzne — globalnie." },
      ],
    },
    process: {
      kicker: "Proces ustanowienia — w pełni jawny",
      title: "Siedem kroków. Każdy publicznie rozliczany.",
      steps: [
        { t: "Konsultacje globalne", d: "Rozmowy z producentami, organizacjami i naukowcami na świecie: historia, kultura, regiony produkcji, sezony zbiorów, istniejące wydarzenia.", status: "W przygotowaniu" },
        { t: "Wybór daty", d: "Wybór daty respektującej sezony zbiorów na obu półkulach i istniejące tradycje krajowe.", status: "Nadchodzące" },
        { t: "Publikacja propozycji", d: "Propozycja Światowego Dnia Rabarbaru — opublikowana jawnie na tej stronie do recenzji.", status: "Nadchodzące" },
        { t: "Poparcie międzynarodowe", d: "Formalne poparcie producentów, uczelni, organizacji rolniczych, firm spożywczych i szefów kuchni.", status: "Nadchodzące" },
        { t: "Kampania globalna", d: "Skoordynowane wydarzenia: dni farmy, targi restauracyjne, konkursy, programy szkolne i uniwersyteckie.", status: "Nadchodzące" },
        { t: "Oficjalne uznanie WRA", d: "Formalne przyjęcie przez WRA po ustanowieniu struktury zarządu.", status: "Nadchodzące" },
        { t: "Szersze uznanie międzynarodowe", d: "Dążenie do uznania przez szersze instytucje międzynarodowe i rolnicze.", status: "Nadchodzące" },
      ],
      active: "W przygotowaniu", upcoming: "Nadchodzące",
      footer: "Osiągnięcia na każdym kroku będą publikowane tutaj w miarę ich realizacji.",
    },
    organizer: {
      kicker: "Zostań organizatorem krajowym",
      titleA: "Przenieś to święto do ", titleAccent: "swojego kraju.",
      para: "Organizatorzy krajowi prowadzą Światowy Dzień Rabarbaru lokalnie — wydarzenia, partnerzy i prasa. Stanowiska są otwarte w każdym kraju, formalnie uznawane przez WRA, z jawnie publikowaną relacją.",
      examples: ["Światowy Dzień Rabarbaru – Japonia", "Światowy Dzień Rabarbaru – Wielka Brytania", "Światowy Dzień Rabarbaru – Polska"],
      open: "Stanowisko wolne",
      cta: "Zgłoś zainteresowanie",
      events: { label: "Wydarzenia na świecie", title: "Brak oficjalnych wydarzeń.", text: "Pierwsze skoordynowane wydarzenia planujemy w fazie kampanii globalnej. Wydarzenia na farmach, targi restauracyjne, konkursy kulinarne i programy edukacyjne pojawią się tutaj — dopiero po potwierdzeniu." },
      supporters: { label: "Globalni zwolennicy", title: "Oficjalni zwolennicy: 0.", text: "Nazwiska zwolenników, kraje, organizacje i stanowiska pojawiają się tutaj wyłącznie po formalnej, pisemnej zgodzie. Rejestr zaczyna się pusty — i rośnie jawnie." },
      resources: { label: "Zasoby Światowego Dnia Rabarbaru", title: "Zestaw organizatora — w przygotowaniu.", text: "Identyfikacja wizualna, szablony plakatów, przewodniki po wydarzeniach i materiały prasowe zostaną opublikowane tutaj dla organizatorów krajowych." },
    },
    support: {
      kicker: "Jak wesprzeć",
      titleA: "Podaruj temu dniu ", titleAccent: "swoje nazwisko.",
      para: "Producenci, uczelnie, organizacje rolnicze, firmy spożywcze, szefowie kuchni i restauracje: zadeklarujcie poparcie dla ustanowienia Światowego Dnia Rabarbaru. Za Waszą zgodą nazwisko trafi do publicznego rejestru — i wyłącznie za zgodą.",
      formTitle: "Wesprzyj Światowy Dzień Rabarbaru — deklaracja",
      ph: { name: "Imię i nazwisko *", email: "E-mail *", country: "Kraj", org: "Organizacja", position: "Stanowisko / Rola" },
      consent: "Wyrażam zgodę na publikację mojego nazwiska, kraju, organizacji i stanowiska jako zwolennika, po formalnym potwierdzeniu przez WRA.",
      submit: "Wesprzyj Światowy Dzień Rabarbaru", submitting: "Wysyłanie…",
      thanks: "Dziękujemy",
      successBase: "Twoja deklaracja poparcia Światowego Dnia Rabarbaru została zapisana.",
      successConsent: " Za Twoją zgodą nazwisko może pojawić się na ścianie globalnych zwolenników po formalnym potwierdzeniu poparcia.",
      successNoConsent: " Twoje nazwisko nie zostanie opublikowane.",
      toastOk: "Deklaracja poparcia zapisana.",
      toastErr: "Wysyłanie nie powiodło się. Spróbuj ponownie.",
    },
  },
  transparency: {
    kicker: "Przejrzystość i zarządzanie",
    h1a: "Dziś mali.", h1b: "Zawsze rozliczalni.",
    para: "WRA to dwuosobowa inicjatywa założona w 2026 roku. Traktujemy tę skromność jako zobowiązanie: wszystko na tej stronie — i w tym serwisie — przedstawia organizację dokładnie taką, jaka jest, i rośnie tylko wraz z rzeczywistością.",
    org: {
      kicker: "Informacje o organizacji",
      facts: [
        ["Nazwa organizacji", "World Rhubarb Association (WRA)"],
        ["Założyciel / Reprezentant", "Kohei Sudo"],
        ["Zespół", "2 osoby"],
        ["Założona", "2026"],
        ["Osobowość prawna", "Brak — dobrowolna inicjatywa międzynarodowa"],
        ["Członkowie zewnętrzni", "0 (sieć fundatorska w budowie)"],
        ["Członkowie zagraniczni", "0"],
        ["Oficjalni partnerzy", "0"],
      ],
    },
    gov: {
      kicker: "Zarządzanie",
      para: "Poniższa struktura została zaprojektowana, by rosnąć — członkowie, potem przedstawiciele, komitety, a w końcu formalny zarząd. Stanowiska pokazujemy dokładnie tak, jak są: obsadzone, planowane lub jeszcze nie ustanowione. Żadna rola nigdy nie jest wyświetlana ze zmyślonym nazwiskiem.",
      filled: "Obsadzone", vacant: "Wakat",
      roles: [
        { role: "Założyciel / Dyrektor wykonawczy", holder: "Kohei Sudo", filled: true },
        { role: "Rada doradcza", holder: "Jeszcze nie ustanowiona", filled: false },
        { role: "Zarząd", holder: "Jeszcze nie ustanowiony", filled: false },
        { role: "Komitet badawczy", holder: "Planowany", filled: false },
        { role: "Komitet producentów", holder: "Planowany", filled: false },
        { role: "Komitet Światowego Dnia Rabarbaru", holder: "Planowany", filled: false },
        { role: "Przedstawiciele krajowi", holder: "Nikt nie powołany — stanowiska wolne", filled: false },
      ],
    },
    docs: {
      kicker: "Dokumenty i publikacje",
      items: [
        { name: "Informacje o organizacji", status: "Opublikowane", note: "Ta strona" },
        { name: "Kierownictwo", status: "Opublikowane", note: "Ta strona" },
        { name: "Polityka członkowska", status: "W przygotowaniu", note: "Publikacja przed wymienieniem jakiegokolwiek członka" },
        { name: "Karta zarządzania", status: "W przygotowaniu", note: "Po sieci fundatorskiej" },
        { name: "Kodeks postępowania", status: "W przygotowaniu", note: "Na wzór praktyk ISO / FAO / IAIA" },
        { name: "Raport roczny FY2026", status: "Publikacja w Q1 2027", note: "Pierwszy pełny rok obrachunkowy" },
        { name: "Informacje finansowe", status: "Do publikacji", note: "Wraz z pierwszym raportem rocznym" },
        { name: "Propozycja Światowego Dnia Rabarbaru", status: "W trakcie badań", note: "Jawna publikacja po ukończeniu" },
        { name: "Źródła badań", status: "W toku", note: "Cytowane przy każdym artykule w Centrum wiedzy" },
      ],
    },
    manifesto: {
      kicker: "Manifest zero przechwałek",
      title: "Zaufanie to jedyna strategia wzrostu, jaką mamy.",
      para: "Organizacja dwóch osób nie może pożyczyć wiarygodności od zmyślonej skali. WRA robi odwrotnie: publikuje swój dokładny rozmiar i pozwala, by rzetelność każdej strony stała się jej reputacją.",
      principles: [
        "Żadnych zmyślonych członków, krajów, partnerów czy poparcia — nigdy.",
        "Tam, gdzie dane nie istnieją, strona mówi: „dane niedostępne”.",
        "Nazwiska publikujemy wyłącznie za formalną, udokumentowaną zgodą.",
        "Światowy Dzień Rabarbaru prezentujemy jako propozycję, dopóki nie zostanie formalnie ustanowiony.",
        "Każda liczba na tej stronie prowadzi do realnego, aktualnego faktu.",
      ],
    },
    models: {
      kicker: "Modele referencyjne",
      para: "Projekt organizacyjny, praktyka przejrzystości i publikowanie wiedzy WRA wzorowane są na uznanych instytucjach międzynarodowych.",
      items: [
        { name: "ISO", desc: "Jawne struktury członków, komitetów i zarządu.", url: "https://www.iso.org/structure.html" },
        { name: "FAO", desc: "Otwarte polityki etyki, postępowania i konfliktu interesów.", url: "https://www.fao.org/ethics/policies/en" },
        { name: "IAIA", desc: "Przejrzystość przez zarząd, finanse i raporty roczne.", url: "https://iaia.org/transparency/" },
        { name: "Royal Horticultural Society", desc: "Systematyczna, poparta źródłami wiedza ogrodnicza.", url: "https://www.rhs.org.uk/vegetables/rhubarb/grow-your-own" },
      ],
      visit: "Odwiedź źródło",
    },
    contact: {
      kicker: "Zapytania formalne",
      para: "Pytania o członkostwo, zarząd i prasa: prosimy o korzystanie z formularza kontaktowego na stronie głównej. Na każde zapytanie odpowiada bezpośrednio zespół fundatorski.",
      cta: "Skontaktuj się z WRA",
    },
  },
};
